export const queryKey = {
    documents: () => ['documents'],
};
